import { Node, Edge } from "@xyflow/react";
import useOrgchartStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Utils/store";
import { IChangeNodesVisibility } from "./utils.models";
// eslint-disable-next-line
import { getAutoLayoutWorker } from "../workers/getOrgchartWebWorker";

const AutoLayoutWorker: Worker | undefined = getAutoLayoutWorker();

interface IWebWorkerReturnType {
  nodes: Node[];
  edges: Edge[];
}

const changeNodesVisibility = ({
  clickedNodeId,
  isClickedNodeCollapsed,
  edges,
}: IChangeNodesVisibility) => {
  const newNodes: Node[] = [];
  // Filter nodes, with parentId === clickedNodeId,
  // And then set hidden to clicked node hidden value
  const updatedChildren: Node[] = useOrgchartStore
    .getState()
    .allNodes.filter((node) => node.data.parentId === clickedNodeId)
    .map((child) => ({
      ...child,
      hidden: !isClickedNodeCollapsed,
    }));

  if (isClickedNodeCollapsed) {
    // Expand Node children
    useOrgchartStore.getState().nodes.forEach((node) => {
      if (
        node.id === "root" ||
        (node.id !== "root" && node.data.parentId !== clickedNodeId)
      ) {
        newNodes.push(node);
      }
      if (node.data.parentId === clickedNodeId) {
        newNodes.push({
          ...node,
          hidden: !isClickedNodeCollapsed,
        });
      }
    });
    updatedChildren.forEach((updatedChild) => {
      if (!newNodes.find((node) => node.id === updatedChild.id)) {
        newNodes.push(updatedChild);
      }
    });
  } else {
    // Collapse Node children, and their children, grandchildren etc.
    const targetNode = useOrgchartStore
      .getState()
      .nodes.find((node) => node.id === clickedNodeId);
    if (!targetNode) {
      return null;
    }

    const newNodesArray: Node[] = [];
    const queue = [targetNode];

    while (queue.length > 0) {
      const current = queue.shift();
      const children = useOrgchartStore
        .getState()
        .nodes.filter((node) => node.data.parentId === current?.id);
      newNodesArray.push(...children);
      queue.push(...children.map((child) => child));
    }

    newNodesArray.forEach((node) => {
      if (node.data.hasChildren) {
        useOrgchartStore
          .getState()
          .setChildrenCollapsedStatus(
            new Map(useOrgchartStore.getState().childrenCollapsedStatus).set(
              node.id,
              true
            )
          );
      }
    });

    useOrgchartStore
      .getState()
      .nodes.map((node) =>
        !newNodesArray.find((newNode) => newNode.id === node.id)
          ? newNodes.push(node)
          : null
      );
  }

  const isAutoLayoutWorkerDefined = typeof AutoLayoutWorker;

  if (isAutoLayoutWorkerDefined !== "undefined") {
    // Get new nodes positions
    AutoLayoutWorker.postMessage({ nodes: newNodes, edges });
    AutoLayoutWorker.onmessage = (
      event: MessageEvent<IWebWorkerReturnType>
    ) => {
      useOrgchartStore.getState().setNodes(event.data.nodes);
    };
  } else if (isAutoLayoutWorkerDefined === "undefined") {
    console.error("AutoLayout failed -> AutoLayoutWorker is undefined");
  }

  return null;
};

export default changeNodesVisibility;
